import React from 'react';
import { ArrowRight } from 'lucide-react';
import { scrollToSection } from '../../lib/navHelpers';

const Hero = ({ hero, editorNote }) => {
  const handleExplore = () => scrollToSection('projects');

  return (
    <section className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 pt-8 pb-10 border-b-2 divider-line">

      {/* Left column */}
      <div className="md:col-span-4 fade-up">
        <span className="inline-block bg-[#8b2331] text-[#f0ebe0] text-[9px] sm:text-[10px] tracking-[0.28em] font-sans-ui px-3 py-1.5">
          {hero.badge}
        </span>

        <h2 className="font-serif-display text-[42px] sm:text-[48px] md:text-[52px] leading-[1.02] tracking-[-0.01em] text-[#0f0f0f] mt-5 md:mt-6">
          {hero.titleStart}<br />
          {hero.titleMid}<br />
          {hero.titleEnd}{' '}
          <span className="italic text-[#8b2331]">
            {hero.titleAccent}
          </span>
        </h2>

        <div className="w-full border-t divider-line mt-5 md:mt-6 pt-4 md:pt-5">
          <p className="font-serif-body text-[16px] sm:text-[17px] leading-relaxed text-[#2a2a2a]">
            {hero.description}
          </p>
        </div>

        <button
          onClick={handleExplore}
          className="newspaper-btn mt-6 md:mt-7 inline-flex items-center gap-3 bg-[#1a1a1a] text-[#f0ebe0] px-5 py-3 text-[10px] sm:text-[11px] tracking-[0.25em] font-sans-ui hover:bg-[#8b2331]"
        >
          {hero.cta}
          <ArrowRight size={14} />
        </button>
      </div>

      {/* Center image */}
      <div className="md:col-span-5 fade-up">
        <div className="relative w-full h-[420px] sm:h-[500px] md:h-[520px] overflow-hidden bg-[#e8e2d3]">
          <img
            src={hero.image}
            alt="Portrait"
            className="w-full h-full object-cover hero-image-treatment"
          />
        </div>
      </div>

      {/* Right column — Editor's Note */}
      <div className="md:col-span-3 fade-up">
        <p className="text-[10px] sm:text-[11px] tracking-[0.28em] font-sans-ui text-[#8b2331] font-medium">
          EDITOR’S NOTE
        </p>

        <h3 className="font-serif-display text-[24px] sm:text-[26px] leading-[1.15] mt-3 text-[#0f0f0f]">
          {editorNote.heading}
        </h3>

        <div className="border-t divider-line mt-5 pt-4">
          <p className="font-serif-body text-[15px] sm:text-[16px] leading-relaxed text-[#2a2a2a]">
            {editorNote.body}
          </p>
        </div>

        <p className="font-signature text-[28px] sm:text-[30px] text-[#1a1a1a] mt-6 leading-none">
          {editorNote.signature}
        </p>

        <p className="text-[9px] sm:text-[10px] tracking-[0.3em] font-sans-ui text-[#1a1a1a] mt-2">
          {editorNote.role}
        </p>
      </div>

    </section>
  );
};

export default Hero;
